// extracted by mini-css-extract-plugin
export default {"wrapper":"twoPlayersPs_wrapper__ufB5y","button":"twoPlayersPs_button__KhNeY"};